/**
 * Nome do item de menu cujo FullPath é o da página. Procura também nos submenus: antes só olhava o 1º nível, então uma entrada dentro de
 * um grupo (ex.: "Grid's Exemplo" → entradas) mostrava o nome do Subject na aba em vez do nome do menu.
 */
export function findMenuName (options, fullPath) {
  for (const option of options || []) {
    if (option.FullPath === fullPath && option.Name) return option.Name

    const nested = findMenuName(option.Menus, fullPath)
    if (nested) return nested
  }

  return undefined
}
